import { render, staticRenderFns } from "./TurnoverView.vue?vue&type=template&id=6236d8da&scoped=true"
import script from "./TurnoverView.vue?vue&type=script&lang=ts"
export * from "./TurnoverView.vue?vue&type=script&lang=ts"
import style0 from "./TurnoverView.vue?vue&type=style&index=0&id=6236d8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236d8da",
  null
  
)

export default component.exports